import { render } from "./GeneralPayroll.vue?vue&type=template&id=56f6fb40&scoped=true"
import script from "./GeneralPayroll.vue?vue&type=script&lang=js"
export * from "./GeneralPayroll.vue?vue&type=script&lang=js"

import "./GeneralPayroll.vue?vue&type=style&index=0&id=56f6fb40&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f6fb40"]])

export default __exports__